import { loader } from 'graphql.macro';

export const surfaceUnionFragment = loader('./index.graphql');
